<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="1200">
    <template v-slot:title>{{ title }}</template>
    <v-data-table :headers="headers" class="elevation-1" :items="items">
      <template v-slot:item.createdAt="{ item }">
        {{ new Date(item.createdAt) | formatDate }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon dark color="indigo" @click="download(item)" v-on="on">
              <v-icon small>file_download</v-icon>
            </v-btn>
          </template>
          Download
        </v-tooltip>
      </template>
    </v-data-table>
    <v-row v-if="debug">
      <v-col>
        <code>
          {{ value }}
        </code>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import { removeGQLTypename } from "../../../helpers";
import TemplateBuilder from "../templates/builder/TemplateBuilder.vue";
import BasicDialog from "./BasicDialog.vue";
export default {
  components: { BasicDialog, TemplateBuilder },
  name: "document-versions-dialog",

  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      headers: [
        { text: "Created At", value: "createdAt" },
        { text: "URL", value: "url" },
        { text: "Published By", value: "publishedByName" },
        { text: "Format", value: "format" },
        { text: "Actions", value: "actions" },
      ],
    };
  },

  computed: {
    items() {
      return this.value && this.value.publishedDocuments
        ? this.value.publishedDocuments.edges.map(removeGQLTypename)
        : [];
    },
    title() {
      return this.value
        ? `${this.value.name} - Document Versions`
        : "Document Versions";
    },
  },

  methods: {
    download(item) {
      console.log("download", item.url);
      window.open(item.url);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/DocumentVersionsDialog.vue